export class AuthSettingsModel {
    authSettings;
    connection;
    emailDomain;
}
//# sourceMappingURL=auth-settings.js.map